import { createInstance } from 'i18next';
import { LOCALE_BUNDLES } from '@shared/config/locale-bundles';

export function createWidgetI18n(locale: 'en' | 'ru') {
  const instance = createInstance();
  void instance.init({
    resources: {
      en: {
        translation: { common: LOCALE_BUNDLES.en.common, helpdesk: LOCALE_BUNDLES.en.helpdesk },
      },
      ru: {
        translation: { common: LOCALE_BUNDLES.ru.common, helpdesk: LOCALE_BUNDLES.ru.helpdesk },
      },
    },
    lng: locale,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru'],
    initImmediate: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
  return instance;
}
